import { LOCAL } from "@/constants/core"

export async function exception(
  error: unknown,
  info: { route: string; method: string; req: unknown },
): Promise<void> {
  if (process.env.NEXT_PUBLIC_APP_ENV !== LOCAL && error !== null) {
    console.error("Exception occurred:", {
      error,
      route: info.route,
      method: info.method,
      request: info.req,
    })
  }
}
